import { DEFAULT_NULL_VALUES } from 'reporting-data/constants/defaultNullValues';
import { getReferenceLabel, getPropertyLabel, getPropertyType, getProperty } from 'reporting-data/v2/dataset/datasetTypes';
import { CURRENCY } from 'reporting-data/constants/property-types';
//@ts-expect-error Untyped dependency
import { formatCurrency } from 'reporting-visualizations/formatters/propertyFormatter';
const getFormattedValue = ({
  valueKey,
  property,
  dataset
}) => {
  if (getPropertyType(dataset, property) === CURRENCY) {
    const propertyInfo = getProperty(dataset, property);
    const currencyCode =
    //@ts-expect-error Typing on these utils is incomplete
    propertyInfo && propertyInfo.format && propertyInfo.format.currencyCode;
    if (currencyCode) {
      return formatCurrency(valueKey, {
        currencyCode
      });
    }
  }
  return getReferenceLabel(dataset, property, valueKey);
};
const formatSummaryMetric = ({
  valueKey,
  property,
  dataset
}) => {
  if (valueKey === DEFAULT_NULL_VALUES.NUMBER) return {
    value: '',
    label: ''
  };
  const formattedValue = getFormattedValue({
    valueKey,
    property,
    dataset
  });
  return {
    label: getPropertyLabel(dataset, property),
    value: formattedValue,
    key: property
  };
};
export const getJourneySummaryMetrics = resolvedReport => {
  const summaryDataset = resolvedReport.resolveDatamap && resolvedReport.resolveDatamap['summary'];
  if (!summaryDataset) return [];
  const summaryMetricProperties = Object.keys(summaryDataset.properties);
  const summaryDatasetKeystore = summaryDataset.data[0];
  return summaryMetricProperties.map(metric => {
    const key = summaryDatasetKeystore[metric];
    return formatSummaryMetric({
      dataset: summaryDataset,
      property: metric,
      valueKey: key
    });
  });
};